import React from 'react'
import styled from 'styled-components'

const Holder = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.3rem 0;
  label {
    margin: 0;
    text-transform: uppercase;
    ${(props) => props.theme.fluidType(-1)};
  }
  input {
    margin: 0;
  }
`

const Slider = ({title, value, onChange, vertical}) => {
  return (

    <Holder>
      <label>
        <span>{title}</span>
      </label>
      <input
        type="range"
        min={0}
        max={100}
        value={value}
        title={title}
        onChange={onChange}
      />
    </Holder>

  )
}

export default Slider
